export default function PublicHeader({ branding, logoUrl, primary, brandInitial, refId }) {
  return (
    <header className="border-b border-white/5 backdrop-blur-xl bg-[#0A0C10]/80 sticky top-0 z-40">
      <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={branding.firm_name}
              className="w-9 h-9 rounded-lg object-cover border"
              style={{ borderColor: `${primary}99` }}
              data-testid="public-brand-logo-img"
            />
          ) : (
            <div
              className="w-9 h-9 rounded-lg border flex items-center justify-center"
              style={{ borderColor: `${primary}99` }}
            >
              <span
                className="font-display font-bold"
                style={{ letterSpacing: "-0.04em", color: primary }}
              >
                {brandInitial}
              </span>
            </div>
          )}
          <div className="leading-tight">
            <div className="font-display font-bold text-[15px]" data-testid="public-brand-firm-name">
              {branding.firm_name}
            </div>
            {branding.tagline ? (
              <div className="overline text-[9px]" style={{ color: `${primary}B3` }}>
                {branding.tagline}
              </div>
            ) : null}
            {branding.show_business_info && (branding.gst_number || branding.address) ? (
              <div
                className="mt-1 text-[10px] text-white/55 leading-tight max-w-[220px] sm:max-w-none"
                data-testid="public-brand-business-info"
              >
                {branding.gst_number ? (
                  <div data-testid="public-brand-gst">
                    <span className="text-white/35">GSTIN</span>{" "}
                    <span className="font-medium text-white/75 tracking-wider">
                      {branding.gst_number}
                    </span>
                  </div>
                ) : null}
                {branding.address ? (
                  <div
                    className="whitespace-pre-line"
                    data-testid="public-brand-address"
                  >
                    {branding.address}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">
          Ref #{refId}
        </div>
      </div>
    </header>
  );
}
